import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
import { Link } from "react-router-dom";

import {
  MDBCarousel,
  MDBCarouselCaption,
  MDBCarouselInner,
  MDBCarouselItem,
  MDBView,
} from "mdbreact";
import Button from 'react-bootstrap/Button';

import carouselItems from "../Helpers/carousel-data";
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  handleButtonClick = (link) => {
    window.open( link,'_blank');
  };
  render() {
    let carousel = carouselItems.items.map((item, key) => {
      return (
        <MDBCarouselItem itemId={item.id} key={key} >
          {/* <MDBView>
                    <div style={{height:"250px", backgroundColor:"#1d39c4"}}></div>
                    <img className="d-block w-100" src="https://mdbootstrap.com/img/Photos/Slides/img%20(68).jpg" alt="First slide" />
                    <MDBMask overlay="black-light" />
                    </MDBView> */}
          <MDBView >
            <img src={item.img} style={{ width: '100vw',  height: "87vh", objectFit: 'cover',  objectPosition: 'center' }} alt="" className="d-block w-100"  loading="eager" />
          </MDBView >
          <MDBCarouselCaption placement='left'>
        
        <div className='fixed-text'>
        <div className='description-box'>
         
            
         <h3 className='line'></h3>
       <h3 className='caption-title'>Facilitating Informed Decision Making</h3>
         <p className='homecontent'>HYDROSiGHT hosts various geo-spatial hydro products generated under   
 National Hydrology Project (NHP) by NRSC, ISRO.  It has functionalities   
 for visualization, query, and download of the products.

         <div style={{ display: "inline-block", justifyContent: "flex-end", position: "absolute",bottom: "1rem",right: "1rem",display: "flex"}}>

         <Button variant="light" size="sm"  color="#ffffff" border="0px"
         as={Link} to={"/about-portal"}> more  <FontAwesomeIcon icon={faChevronRight}></FontAwesomeIcon>
         </Button>
         </div>
       </p>
       
       </div>
      
    </div>

      </MDBCarouselCaption>
        </MDBCarouselItem>
      );
    });

    return (
      <div >
        <MDBCarousel
          activeItem={1}
          length={carouselItems.items.length}
          showControls={false}
          showIndicators={true}
          className="z-depth-1"
        >
          <MDBCarouselInner>{carousel}</MDBCarouselInner>
        </MDBCarousel>
      </div>
    );
  }
}

export default Slider;
